module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/coffee-1-45024b9a829a1d79ffe67ffa7b865f2f.svg";